const PrivacyPolicy = () => {
    return <h1>Privacy Policy</h1>;
};

export default PrivacyPolicy;
